import { useMemo } from 'react'

import { BRAND_LOCATION_GROUP_ID } from 'pared/constants/brands'
import useBrands from 'pared/layouts/hooks/useBrands'

import { useVariables } from '../../../variables'
import {
  useLocationMetricTrendsHook,
  useSystemwideMetricTrendsHook,
} from '../common/delivery/useTrendLocationDelivery'

export const bbbTrendLocationDeliveryConfigs = {
  date: 'string',
  deliveryCorrectOrderPercentDoordash: 'percent',
  systemwideDeliveryCorrectOrderPercentDoordash: 'percent',
} as const

const useBbbTrendLocationDelivery = () => {
  const { variables } = useVariables()
  const { brand } = useBrands()
  const dateRange = useMemo(() => {
    switch (variables.date?.value.type) {
      case 'year':
        return 'business_quarter'
      case 'quarter':
        return 'business_month'
      case 'period':
        return 'business_week'
      case 'week':
        return 'business_day'
      default:
        return 'business_day'
    }
  }, [variables])
  const { data, loading } = useLocationMetricTrendsHook(dateRange)
  const { data: systemwideData, loading: systemwideLoading } =
    useSystemwideMetricTrendsHook(dateRange, {
      customLocationGroupIds: [BRAND_LOCATION_GROUP_ID[brand]],
      shouldBypassRowLevelSecurity: true,
    })

  return {
    data: useMemo(() => {
      if (!data || !systemwideData) return null

      return systemwideData.map((s) => {
        const d = data.find((d) => d.date === s.date)

        return {
          date: s.date,
          systemwideDeliveryCorrectOrderPercentDoordash:
            s.deliveryCorrectOrderPercentDoordash,
          deliveryCorrectOrderPercentDoordash:
            d?.deliveryCorrectOrderPercentDoordash,
        }
      })
    }, [data, systemwideData, dateRange]),
    loading: loading || systemwideLoading,
  }
}

export default useBbbTrendLocationDelivery
